import React from 'react';
import { Store } from 'redux';
import { History } from 'history';
import XRRoot from './xr/root';
import DefaultRoot from './default/root';

type RootProps = {
  store: Store;
  history: History;
};

const Root = ({ history, store }: RootProps) => {
  return (
    <>
      <XRRoot history={history} store={store} />
      <DefaultRoot history={history} store={store} />
    </>
  );
};

export default Root;
